import {
  faCalendar,
  faFileCheck,
  faFileInvoiceDollar,
  faFilePen,
  faHouse,
  faList,
  faMoped,
  faBoxIsometricTape,
  faUserGroup,
} from '@fortawesome/pro-solid-svg-icons';
import { faBullseyeArrow } from '@fortawesome/pro-regular-svg-icons';
import type { Menu } from '@/Interfaces/Data';
import { ROLE_TYPES } from '@/Interfaces/Data';
import { MONITOR_DELIVERIES_PERMISSIONS } from '@/_features/monitor-deliveries/constants';

export interface CategoryMenu {
  title?: string;
  key?: string;
  keyPermissao?: string;
  permissions: ROLE_TYPES[];
  menus: Menu[];
}

export const SIDE_BAR_PAGES: CategoryMenu[] = [
  {
    key: 'home',
    permissions: [
      ROLE_TYPES.ADMIN,
      ROLE_TYPES.LOGISTIC_OPERATOR,
      ROLE_TYPES.SUPPORT,
    ],
    menus: [
      {
        title: 'Página inicial',
        key: 'inicio',
        icon: faHouse,
        href: '/',
        permissions: [
          ROLE_TYPES.ADMIN,
          ROLE_TYPES.LOGISTIC_OPERATOR,
          ROLE_TYPES.SUPPORT,
        ],
      },
    ],
  },
  {
    title: 'PEDIDOS',
    key: 'pedidos',
    permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
    menus: [
      {
        title: 'Monitor de entregas',
        key: 'monitor-entregas',
        icon: faBoxIsometricTape,
        href: '/monitor-entregas',
        routeLabel: 'Monitor de entregas',
        permissions: MONITOR_DELIVERIES_PERMISSIONS,
        stageOnly: true,
      },
      {
        title: 'Entregas',
        desc: 'Acompanhe as entregas',
        key: 'entregas',
        icon: faMoped,
        href: '/entregas',
        routeLabel: 'Entregas',
        permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
      },
    ],
  },
  {
    title: 'ENTREGADORES',
    key: 'entregadores',
    permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
    menus: [
      {
        title: 'Lista',
        key: 'listagem',
        href: '/entregadores',
        routeLabel: 'Lista',
        icon: faFileCheck,
        permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
      },
    ],
  },
  {
    title: 'PRÉ-CADASTRO',
    key: 'precadastro',
    permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
    menus: [
      {
        title: 'Esteira de aprovação',
        key: 'precadastro',
        href: '/precadastro',
        routeLabel: 'Esteira de aprovação',
        icon: faList,
        permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
      },
    ],
  },
  {
    title: 'ESTABELECIMENTOS',
    key: 'estabelecimentos',
    permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
    menus: [
      {
        title: 'Cadastro e gerenciamento',
        key: 'gerenciamento',
        icon: faFilePen,
        href: '/estabelecimentos',
        routeLabel: 'Cadastro e gerenciamento',
        permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
      },
    ],
  },
  {
    title: 'OUTROS',
    key: 'outros',
    permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
    menus: [
      {
        title: 'Equipe',
        key: 'equipe',
        icon: faUserGroup,
        href: '/equipe',
        routeLabel: 'Equipe',
        permissions: [ROLE_TYPES.ADMIN],
      },
      {
        title: 'Eventos',
        key: 'eventos',
        icon: faCalendar,
        href: '/eventos',
        routeLabel: 'Eventos',
        permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
      },
      {
        title: 'Tarifas',
        key: 'tarifas',
        icon: faFileInvoiceDollar,
        href: '/tarifas',
        routeLabel: 'Tarifas',
        permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
      },
      {
        title: 'Missões',
        key: 'missoes',
        icon: faBullseyeArrow,
        href: '/missoes',
        routeLabel: 'Missões',
        permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT],
      },
    ],
  },
];
